(function () {
if (window.__tzCalendarCartInit) return;
window.__tzCalendarCartInit = true;
var STORAGE_KEY = 'tiziano.calendarCart.deferred.v1';
var stripInFlight = false;
var lastStrippedKeys = '';
var stripAttempts = 0;
var stripRetryTimer = null;
var operationInFlight = false;
function roots() {
return Array.from(document.querySelectorAll('[data-tz-calendar-cart]'));
}
function payload(root) {
try {
return JSON.parse(root.querySelector('[data-tz-calendar-payload]').textContent);
} catch (error) {
return { items: [] };
}
}
function deferredItems() {
try {
var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
return data && Array.isArray(data.items) ? data : null;
} catch (error) {
return null;
}
}
function showStatus(root, selector, message) {
var target = root.querySelector(selector);
if (!target) return;
target.textContent = message;
target.hidden = false;
}
function setBusy(button, busy) {
button.disabled = busy;
button.setAttribute('aria-busy', busy ? 'true' : 'false');
}
function showCalendarOnlyCopy(root) {
if (root.dataset.hasCalendar !== 'true' || root.dataset.hasRegular === 'true') return;
var copy = root.querySelector('.tz-calendar-cart__copy');
if (copy) copy.textContent = 'Nur Kalender im Warenkorb – gemeinsamer Versand im November.';
var details = root.querySelector('.tz-calendar-cart__details');
if (!details) return;
var summary = details.querySelector('summary');
var explanation = details.querySelector('p');
if (summary) summary.textContent = 'Versandhinweis';
if (explanation) explanation.textContent = 'Adventskalender werden separat versendet. Gratisgeschenke nach Einkaufswert gelten nicht für Adventskalender.';
}
function request(url, body) {
return fetch(url, {
method: 'POST',
credentials: 'same-origin',
headers: {
'Content-Type': 'application/json',
'Accept': 'application/json'
},
body: JSON.stringify(body)
}).then(function (response) {
if (!response.ok) throw new Error('cart-request-failed');
return response.json();
});
}
function currentState() {
var allRoots = roots();
return {
hasCalendar: allRoots.some(function (root) { return root.dataset.hasCalendar === 'true'; }),
hasGift: allRoots.some(function (root) { return root.dataset.hasGift === 'true'; }),
isMixed: allRoots.some(function (root) { return root.dataset.isMixed === 'true'; }),
calendarGiftOnly: allRoots.some(function (root) { return root.dataset.calendarGiftOnly === 'true'; })
};
}
function updateDeferredBanner() {
var saved = deferredItems();
roots().forEach(function (root) {
var banner = root.querySelector('[data-tz-deferred]');
if (!banner) return;
if (!saved || saved.items.length === 0) {
banner.hidden = true;
return;
}
var cartEmpty = root.dataset.cartEmpty === 'true';
var count = saved.items.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);
var copy = banner.querySelector('[data-tz-deferred-copy]');
var restore = banner.querySelector('[data-tz-restore-deferred]');
var details = banner.querySelector('.tz-calendar-cart__deferred-explanation');
var title = banner.querySelector('.tz-calendar-cart__deferred-summary-copy strong');
if (title) title.textContent = saved.group === 'calendar' ? 'Adventskalender vorgemerkt' : 'Artikel für danach vorgemerkt';
banner.hidden = false;
if (copy) {
copy.textContent = cartEmpty
? count + (count === 1 ? ' Artikel kann' : ' Artikel können') + ' jetzt zurück in den Warenkorb.'
: count + (count === 1 ? ' Artikel ist' : ' Artikel sind') + ' für danach gespeichert.';
}
if (restore) restore.hidden = !cartEmpty;
if (details) details.hidden = cartEmpty;
});
}
function giftStatus(message, retry) {
roots().forEach(function (root) {
if (root.dataset.hasCalendar !== 'true') return;
showStatus(root, '[data-tz-calendar-status]', message);
var target = root.querySelector('[data-tz-calendar-status]');
if (retry && target) {
var button = document.createElement('button');
button.type = 'button';
button.className = 'tz-calendar-cart__button tz-calendar-cart__button--secondary';
button.dataset.tzRetryGift = 'true';
button.textContent = 'Erneut prüfen';
target.appendChild(button);
}
});
}
function stripGiftsWhenCalendarPresent() {
var state = currentState();
if (!(state.hasCalendar && state.hasGift)) {
lastStrippedKeys = '';
stripAttempts = 0;
return;
}
if (stripInFlight || stripRetryTimer || operationInFlight) return;
var giftItems = [];
roots().forEach(function (root) {
payload(root).items.forEach(function (item) {
if (item.group === 'gift') giftItems.push(item);
});
});
if (!giftItems.length) return;
var keysSignature = giftItems.map(function (item) { return item.key; }).sort().join(',');
if (keysSignature !== lastStrippedKeys) stripAttempts = 0;
if (stripAttempts >= 3) return;
lastStrippedKeys = keysSignature;
stripAttempts += 1;
stripInFlight = true;
giftStatus('Das Gratisgeschenk wird entfernt. Einen Moment bitte.', false);
var updates = {};
giftItems.forEach(function (item) { updates[item.key] = 0; });
request('/cart/update.js', { updates: updates })
.then(function (updatedCart) {
if (updatedCart.items.some(function (item) { return (item.handle || '').indexOf('docapp-free-gift-') !== -1; })) {
throw new Error('gift-still-present');
}
roots().forEach(function (root) {
root.dataset.hasGift = 'false';
root.dataset.calendarGiftOnly = 'false';
showCalendarOnlyCopy(root);
var status = root.querySelector('[data-tz-calendar-status]');
if (status) status.hidden = true;
});
giftItems.forEach(function (item) {
['CartItem-', 'CartDrawer-Item-'].forEach(function (prefix) {
var row = document.getElementById(prefix + item.key);
if (row) row.remove();
});
});
document.querySelectorAll('cart-count, [data-cart-count]').forEach(function (el) {
el.textContent = String(updatedCart.item_count);
el.hidden = updatedCart.item_count === 0;
});
applyGuardState();
document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
})
.catch(function () {
if (stripAttempts < 3) {
giftStatus('Die Verbindung wurde unterbrochen. Wir versuchen es erneut.', false);
stripRetryTimer = window.setTimeout(function () {
stripRetryTimer = null;
stripGiftsWhenCalendarPresent();
}, stripAttempts * 1000);
} else {
giftStatus('Das Gratisgeschenk konnte nicht entfernt werden. Bitte prüfe die Verbindung und versuche es erneut. Dein Kalender bleibt im Warenkorb.', true);
}
})
.finally(function () { stripInFlight = false; });
}
function hideGiftRowsImmediately() {
if (!currentState().hasCalendar) return;
document.querySelectorAll('.cart-item--reward-gift').forEach(function (row) {
if (row.style.display !== 'none') row.style.display = 'none';
});
}
function applyGuardState() {
hideGiftRowsImmediately();
var state = currentState();
document.documentElement.classList.toggle('tz-cart-has-calendar', state.hasCalendar);
document.documentElement.classList.toggle('tz-cart-is-mixed', state.isMixed);
document.documentElement.classList.toggle('tz-cart-calendar-gift-only', state.calendarGiftOnly);
var blockCheckout = state.isMixed || (state.hasCalendar && state.hasGift);
document.querySelectorAll('button[name="checkout"][form], input[name="checkout"][form], form[action*="/cart"] button[name="checkout"], form[action*="/cart"] input[name="checkout"]').forEach(function (button) {
if (blockCheckout) {
button.disabled = true;
button.setAttribute('aria-disabled', 'true');
button.dataset.tzCalendarDisabled = 'true';
} else if (button.dataset.tzCalendarDisabled === 'true') {
button.disabled = false;
button.removeAttribute('aria-disabled');
delete button.dataset.tzCalendarDisabled;
}
});
updateDeferredBanner();
stripGiftsWhenCalendarPresent();
}
function splitCart(button) {
var root = button.closest('[data-tz-calendar-cart]');
if (!root || operationInFlight || stripInFlight) return;
var keep = button.dataset.tzSplitKeep;
var items = payload(root).items;
var deferred = items.filter(function (item) { return item.group !== keep && item.group !== 'gift'; });
var removed = items.filter(function (item) {
if (item.group === 'gift') return keep === 'calendar';
return item.group !== keep;
});
if (!deferred.length || !removed.length) {
showStatus(root, '[data-tz-calendar-status]', 'Die Versandgruppen konnten nicht eindeutig getrennt werden. Es wurde nichts verändert.');
return;
}
operationInFlight = true;
var previousSaved = deferredItems();
var savedBeforeRemoval = false;
setBusy(button, true);
root.querySelectorAll('[data-tz-split-keep]').forEach(function (other) { other.disabled = true; });
fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
.then(function (response) { if (!response.ok) throw new Error('cart-read-failed'); return response.json(); })
.then(function (liveCart) {
var liveKeys = {};
liveCart.items.forEach(function (item) { liveKeys[item.key] = item; });
var removedLive = removed.filter(function (item) { return liveKeys[item.key]; });
var deferredLive = deferred.filter(function (item) { return liveKeys[item.key]; }).map(function (item) {
return Object.assign({}, item, { quantity: liveKeys[item.key].quantity, properties: liveKeys[item.key].properties || {} });
});
var knownKeys = items.map(function (item) { return item.key; });
if (liveCart.items.some(function (item) { return knownKeys.indexOf(item.key) === -1 && (item.handle || '').indexOf('docapp-free-gift-') === -1; })) {
throw new Error('cart-changed');
}
if (!deferredLive.length || !removedLive.length) {
root.querySelectorAll('[data-tz-split-keep]').forEach(function (other) { other.disabled = false; });
operationInFlight = false;
setBusy(button, false);
showStatus(root, '[data-tz-calendar-status]', 'Die Versandgruppen konnten nicht eindeutig getrennt werden. Es wurde nichts verändert.');
return;
}
localStorage.setItem(STORAGE_KEY, JSON.stringify({
createdAt: new Date().toISOString(),
group: previousSaved && previousSaved.group !== deferredLive[0].group ? 'mixed' : deferredLive[0].group,
items: (previousSaved ? previousSaved.items : []).concat(deferredLive.map(function (item) {
return {
id: item.id,
quantity: item.quantity,
title: item.title,
group: item.group,
properties: item.properties || {},
selling_plan: item.selling_plan || null
};
}))
}));
savedBeforeRemoval = true;
var updates = {};
removedLive.forEach(function (item) { updates[item.key] = 0; });
return request('/cart/update.js', { updates: updates })
.then(function () { window.location.assign('/cart?tz_split=1'); })
.catch(function () {
return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
.then(function (response) { if (!response.ok) throw new Error('cart-read-failed'); return response.json(); })
.then(function (cart) {
var present = deferredLive.filter(function (item) { return cart.items.some(function (live) { return live.key === item.key; }); });
if (present.length === 0) { window.location.assign('/cart?tz_split=1'); return; }
if (present.length === deferredLive.length) {
if (previousSaved) localStorage.setItem(STORAGE_KEY, JSON.stringify(previousSaved));
else localStorage.removeItem(STORAGE_KEY);
savedBeforeRemoval = false;
}
throw new Error('split-not-confirmed');
});
});
})
.catch(function () {
operationInFlight = false;
root.querySelectorAll('[data-tz-split-keep]').forEach(function (other) { other.disabled = false; });
setBusy(button, false);
showStatus(root, '[data-tz-calendar-status]', savedBeforeRemoval ? 'Die Aufteilung konnte nicht bestätigt werden. Deine Artikel bleiben vorgemerkt. Bitte lade den Warenkorb neu und prüfe ihn, bevor du weiterbestellst.' : 'Der Warenkorb konnte nicht aufgeteilt werden. Bitte lade ihn neu und versuche es erneut.');
});
}
function restoreDeferred(button) {
var root = button.closest('[data-tz-calendar-cart]');
var saved = deferredItems();
if (!root || !saved || !saved.items.length || operationInFlight) return;
operationInFlight = true;
setBusy(button, true);
fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
.then(function (response) { if (!response.ok) throw new Error('cart-read-failed'); return response.json(); })
.then(function (cart) {
if (cart.item_count > 0) throw new Error('cart-not-empty');
var items = saved.items.map(function (item) {
var entry = {
id: item.id,
quantity: item.quantity
};
if (item.properties && !Array.isArray(item.properties) && Object.keys(item.properties).length) {
entry.properties = item.properties;
}
if (item.selling_plan) entry.selling_plan = item.selling_plan;
return entry;
});
return request('/cart/add.js', { items: items });
})
.then(function () {
localStorage.removeItem(STORAGE_KEY);
window.location.assign('/cart?tz_restored=1');
})
.catch(function (error) {
operationInFlight = false;
setBusy(button, false);
showStatus(root, '[data-tz-deferred-status]', error.message === 'cart-not-empty'
? 'Bitte schließe zuerst die aktuelle Bestellung ab. Danach kannst du die vorgemerkten Artikel in den leeren Warenkorb zurückholen.'
: 'Die vorgemerkten Artikel konnten nicht geladen werden. Sie bleiben gespeichert; bitte versuche es erneut.');
});
}
document.addEventListener('click', function (event) {
var checkout = event.target.closest('button[name="checkout"][form], input[name="checkout"][form], form[action*="/cart"] button[name="checkout"], form[action*="/cart"] input[name="checkout"]');
if (checkout && (currentState().isMixed || (currentState().hasCalendar && currentState().hasGift))) {
event.preventDefault();
var mixedRoot = roots().find(function (candidate) { return candidate.dataset.isMixed === 'true' || candidate.dataset.calendarGiftOnly === 'true'; });
if (mixedRoot) showStatus(mixedRoot, '[data-tz-calendar-status]', 'Bitte wähle zuerst, welche Versandgruppe du bestellen möchtest.');
return;
}
var retryGift = event.target.closest('[data-tz-retry-gift]');
if (retryGift) {
event.preventDefault();
stripAttempts = 0;
stripGiftsWhenCalendarPresent();
return;
}
var split = event.target.closest('[data-tz-split-keep]');
if (split) {
event.preventDefault();
splitCart(split);
return;
}
var restore = event.target.closest('[data-tz-restore-deferred]');
if (restore) {
event.preventDefault();
restoreDeferred(restore);
}
});
document.addEventListener('cart:updated', function () {
window.setTimeout(applyGuardState, 100);
});
document.addEventListener('cart:refresh', function () {
window.setTimeout(applyGuardState, 350);
});
if (window.MutationObserver) {
var giftRowWatcher = new MutationObserver(function (mutations) {
var sawGiftNode = false;
mutations.forEach(function (mutation) {
(mutation.addedNodes || []).forEach(function (node) {
if (node.nodeType !== 1) return;
if (node.matches && node.matches('.cart-item--reward-gift')) sawGiftNode = true;
if (node.querySelector && node.querySelector('.cart-item--reward-gift')) sawGiftNode = true;
});
});
if (sawGiftNode) {
hideGiftRowsImmediately();
applyGuardState();
}
});
giftRowWatcher.observe(document.documentElement, { childList: true, subtree: true });
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', applyGuardState, { once: true });
} else {
applyGuardState();
}
})();
